<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Login</h2>
                            <!-- <p>Login to account is limited for the users who was invited to the event and received their username and password.</p> -->
                            <p>Login to account is limited for the users who are invited to the EFG Hermes & Tadawul Investor Conference.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <form >
            <section class="section section-sm">
                <div class="container">
                    <div class="no-free-will">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset>
                                    <legend>Login Details</legend>
                                    <div class="alert alert-danger" v-if="errorMsg != ''">
                                         {{ errorMsg }}
                                    </div>
                                    <table>
                                        <tr><td>
                                            <div class="form-group" :class="{ 'has-error': $v.username.$error }">
                                                <label> username <span>*</span></label>
                                                <input v-model="username" type="text" />
                                                  <small class="text-danger" v-if="!$v.username.required">Field is required</small>
                                            </div>
                                        </td></tr>
                                        <tr><td>
                                           <div class="form-group" :class="{ 'has-error': $v.password.$error }">
                                                <label> password <span>*</span></label>
                                                <input v-model="password" type="password" />
                                                <small class="text-danger" v-if="!$v.password.required">Field is required</small>
                                            </div>
                                        </td></tr>
                                        <tr>
                                            <a href="/auth/password/email">Forgot password</a>
                                        </tr>
                                    </table>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section-sm">
                <div class="container">
                    <div class="no-free-will">
                        <div class="row">
                            <div class="col-md-8">
                                <input @click.prevent="loginFormSubmitted" :disabled="!enableLoggin" value="Submit" type="submit" class="btn btn-outline-clr btn-sm" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>
    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required, minLength, between } from 'vuelidate/lib/validators'
import Api from '@/Api'
export default {
    name: 'login',
    components: {Layout},
    data() {
        return {
            username: "",
            password:"",
            // conference_id:13,
            enableLoggin: true,
            errorMsg : '',
        };
    },
    validations: {
        username: {
          required,
        },
        password: {
          required
        },
    },
    methods: {
        loginFormSubmitted() {
            var scope = this;
            scope.errorMsg = '';

            if (this.$v.$invalid)
                return;

            let data = {
                name: this.username,
                password: this.password,
                // conference_id:this.conference_id
            };

            Api().post('auth/signin', data).then((response) => {
                let user = response.data.user;
                if(user)
                {
                    this.$store.dispatch("login", {
                        user: user,
                      }).then((isFinished) => {
                        if (isFinished) {
    
                            let redirect = this.$route.query.redirect;
                            // let redirect = localStorage.getItem('redirect');
                            // localStorage.removeItem('redirect');
                            localStorage.setItem("firstTimeRegister" , "0" );
                            window.location = redirect ? redirect : '/auth/registration/signup';
                        }
                        // this.$router.push({name:"preferences"})
                      });
                }
                else throw new Error('');
            }).catch((error) => {
            //console.log(error)
                if (error) {
                    if (error.response && error.response.status == 422) {
                        var err = error.response.data;
                        scope.errorMsg = err.errors[0].message;
                    } else {
                        scope.errorMsg = "Something Went Wrong";
                    }
                } 
            });

        }
    }
}
</script>
